import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";
import Pagetitle from "../elements/Pagetitle";
// import Service from "../elements/Service";
import ServiceStatic from "../elements/ServiceStatic";
import axios from "axios";
import { getStrapiURL } from "../../lib/api";

const servicesData = [
  {
    id: 1,
    icon: "images/services/conseil.svg",
    title: "Technical Consulting & Strategy",
    content:
      "Strategic technology consulting for startups and enterprises. Expert guidance on tech stack selection, architecture design, digital transformation, and scalable solutions tailored to Canadian market needs.",
    color: "#6C6CE5",
    contentColor: "light",
    keywords: ["Architecture", "Strategy", "Consulting", "Tech Stack"],
  },
  {
    id: 2,
    icon: "images/service-2.svg",
    title: "Full-Stack Web Development",
    content:
      "End-to-end web application development using React, Next.js, TypeScript, Node.js, and modern frameworks. Building responsive, fast, and secure platforms with REST/GraphQL APIs, cloud deployment, and CI/CD pipelines.",
    color: "#F9D74C",
    contentColor: "dark",
    keywords: ["React", "Node.js", "TypeScript", "GraphQL"],
  },
  {
    id: 3,
    icon: "images/service-1.svg",
    title: "Mobile App Development",
    content:
      "Cross-platform mobile solutions with React Native for iOS and Android. From MVP to production, delivering native-quality apps with offline capabilities, push notifications, and seamless UX.",
    color: "#227E8B",
    contentColor: "light",
    keywords: ["React Native", "iOS", "Android", "Mobile"],
  },
  {
    id: 4,
    icon: "images/services/market.svg",
    title: "Cloud Architecture & DevOps",
    content:
      "Scalable cloud infrastructure on AWS, Azure, or GCP. Containerization with Docker/Kubernetes, automated deployments, monitoring, and infrastructure-as-code for high-availability systems.",
    color: "#F9744B",
    contentColor: "light",
    keywords: ["AWS", "Docker", "Kubernetes", "CI/CD"],
  },
  {
    id: 5,
    icon: "images/services/seo.svg",
    title: "Performance & SEO Optimization",
    content:
      "Web performance audits, Core Web Vitals optimization, and technical SEO. Improving page speed, accessibility, and search rankings to maximize user engagement and organic traffic.",
    color: "#F97B8B",
    contentColor: "light",
    keywords: ["Performance", "SEO", "Core Web Vitals", "Analytics"],
  },
  {
    id: 6,
    icon: "images/services/maintain.svg",
    title: "Code Review & Team Leadership",
    content:
      "Technical leadership, code quality reviews, security audits, and team mentoring. Refactoring legacy systems, implementing best practices, and ensuring long-term maintainability of your codebase.",
    color: "#718E52",
    contentColor: "light",
    keywords: ["Leadership", "Code Quality", "Security", "Mentoring"],
  },
];

function Services() {

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [services, setServices] = useState(null);
  
  // useEffect(() => {
  //   const fetchServiceData = async () => {
  //     setLoading(true);
  //     try {
  //       let url = getStrapiURL("/api/services?populate=*");
  //       const res = await axios.get(url);
  //       console.log("data fetched service", res.data.data);
  //       setServices(res.data.data);
  //       setLoading(false);
  //     } catch (error) {
  //       setError(error);
  //       setLoading(false);
  //     }
  //   };
  //   fetchServiceData();
  // }, []);

  return (
    <section id="services">
      <div className="container">
        <Pagetitle title="Services & Expertise" />
        <div className="services-intro text-center mb-5">
          <h3 className="section-subtitle">Comprehensive Solutions for Modern Businesses</h3>
          <p className="section-description">
            From concept to deployment, I provide end-to-end development services that combine technical excellence with business value
          </p>
        </div>
        <div className="row fix-spacing">
          {servicesData?.map((service) => (
            <div className="col-md-4" key={service?.id}>
              <ServiceStatic service={service} />
            </div>
          ))}
        </div>
        <div className="mt-5 text-center service-footer">
          <div className="service-highlights mb-4">
            <div className="row">
              <div className="col-md-3 col-6 mb-3">
                <div className="highlight-item">
                  <i className="icon-clock"></i>
                  <h5>Fast Delivery</h5>
                  <p className="small">Agile sprints</p>
                </div>
              </div>
              <div className="col-md-3 col-6 mb-3">
                <div className="highlight-item">
                  <i className="icon-shield"></i>
                  <h5>Secure Code</h5>
                  <p className="small">Best practices</p>
                </div>
              </div>
              <div className="col-md-3 col-6 mb-3">
                <div className="highlight-item">
                  <i className="icon-speedometer"></i>
                  <h5>High Performance</h5>
                  <p className="small">Optimized apps</p>
                </div>
              </div>
              <div className="col-md-3 col-6 mb-3">
                <div className="highlight-item">
                  <i className="icon-bubbles"></i>
                  <h5>Clear Communication</h5>
                  <p className="small">Regular updates</p>
                </div>
              </div>
            </div>
          </div>
          <p className="mb-0 service-cta-text">
            Looking for a custom solution?{" "}
            <Link
              className="colorpink pointer"
              to="section-contact"
              spy={true}
              smooth={true}
              duration={500}
            >
              Let's discuss your project
            </Link>{" "}
            and bring your vision to life! 🚀
          </p>
        </div>
      </div>
    </section>
  );
}

export default Services;
